__turbopack_context__.v({
  "link": "_9wUqOW_link",
  "reactions": "_9wUqOW_reactions",
  "title": "_9wUqOW_title",
});
